
const judgeClient = () => {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // 判断是否是 android终端
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // 判断是否是 iOS终端
  console.log('是否是Android：' + isAndroid)
  console.log('是否是iOS：' + isIOS)
  if (isAndroid) {
    return 'Android'
  } else if (isIOS) {
    return 'IOS'
  } else {
    return 'PC'
  }
}
const channelArray = []
if(judgeClient() === 'IOS'){
  window.nativePushToWeb = function (nativeValue) {
    console.log('nativeValue', nativeValue)
    console.log(JSON.parse(nativeValue))
    const parsedData = JSON.parse(nativeValue)
    const { response } = parsedData
    const { data } = response
    const { callbackId } = data
    const cbChannel = channelArray.find(item => parseInt(item.callbackId) === parseInt(callbackId))
    if (cbChannel && cbChannel.channel) {
      cbChannel.channel.port1.postMessage(parsedData)
    } else {
      console.error('can not find channel 1')
    }
  }
}


/**
 * js 调ios native
 * @param {*} name // 方法名
 * @param {*} iosParam // 参数
 * @param {*} defaultValue// 出错时默认的返回值
 */
const iosPostMessage = (() => {
  let callbackId = 0
  return (payload, defaultValue = null) => {
    try {
      callbackId += 1
      const channel = new MessageChannel()
      channelArray.push({ callbackId, channel })
      payload.callbackId = callbackId + ''
      const encodedMessageJson = encodeURIComponent(JSON.stringify(payload))
      console.log('payload', payload)
      console.log('prompt 参数', 'litmatch://litatom/com/bridge?message=', encodedMessageJson)
      window.prompt('litmatch://litatom/com/bridge?message=' + encodedMessageJson)
      return new Promise((resolve, reject) => {
        const postChannel = channelArray.find(item => parseInt(item.callbackId) === parseInt(callbackId))
        if (postChannel && postChannel.channel) {
          postChannel.channel.port2.onmessage = function (e) {
            console.log('数据返回', e.data)
            resolve(e.data)
            const delIndex = channelArray.findIndex(item => parseInt(item.callbackId) === parseInt(e.data.callBackId))
            channelArray.splice(delIndex, 1)
            console.log('channel Array remain...', channelArray)
          }
        } else {
          console.error('can not find channel 2')
          return Promise.resolve(defaultValue)
        }
      })
    } catch (err) {
      console.warn('ios err', 'name', err)
      return Promise.resolve(defaultValue)
    }
  }
})()

// ios
const iOSBridge = {
  async getAppTheme () {
    const payload = {
      action: 'getAppThemeInfo',
      params: {}
    }
    const queryParam = await iosPostMessage(payload)
    return queryParam
  },
  async hideNav () {
    console.log('bridge hidenNav')
    const payload = {
      action: 'setNavbarType',
      params: {
        hideNavBar: 'hide',
        statusBarType: 'light'
      }
    }
    const queryParam = await iosPostMessage(payload)
    return queryParam
  },
  async getDeviceSizeInfo () {
    const payload = {
      action: 'getDeviceSizeInfo',
      params: {}
    }
    const queryParam = await iosPostMessage(payload)
    return queryParam
  },
  jump2Activity (){},
  jump2ActivityByRoute(){},
  showToast() {},
  getStatusBarHeight() {},
}

export default iOSBridge
